<div *ngIf="isSkeletonLoading">
  <post-login-layout-skeleton></post-login-layout-skeleton>
</div>
<div class="component-viewer" *ngIf="!isSkeletonLoading">
  <router-outlet name="outingOutlet"></router-outlet>
</div>